import { render, staticRenderFns } from "./DocumentContentViewer.vue?vue&type=template&id=d1bd45d2&scoped=true"
import script from "./DocumentContentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentContentViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentContentViewer.vue?vue&type=style&index=0&id=d1bd45d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bd45d2",
  null
  
)

export default component.exports